import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Content = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${theme.spacing.xs};
`

export const DownloadLink = styled.span`
  display: flex;
  align-items: center;
  color: ${theme.colors.ion.danger.strong};
  cursor: pointer;
  text-decoration: underline;
`
